import { SGMarket, USMarket, AUMarket, CAMarket, UKMarket, UserBusinessFeatures } from '@castlery/modules-user-domain';
import { EcEnv } from '@castlery/config';
// import { featureManager, FeatureName } from '@castlery/monorepo-features';

class MarketFactory {
  static getMarket(market: typeof EcEnv.NEXT_PUBLIC_COUNTRY): UserBusinessFeatures {
    switch (market) {
      case 'SG':
        return new SGMarket();
      case 'US':
        return new USMarket();
      case 'AU':
        return new AUMarket();
      case 'CA':
        return new CAMarket();
      case 'UK':
        return new UKMarket();
      default:
        throw new Error('Invalid market');
    }
  }
}

// class DomainFeatureService {
//   static isFeatureEnabled(featureName: FeatureName): boolean {
//     return featureManager.isFeatureEnabled(featureName);
//   }
//   static getFeatureFlagPayload(featureName: FeatureName) {
//     return featureManager.getFeatureFlagPayload(featureName);
//   }
// }

export const userFeatureService = MarketFactory.getMarket(EcEnv.NEXT_PUBLIC_COUNTRY);
